// extracted by mini-css-extract-plugin
export var container = "Benefits-module--container--3gu4k";
export var wrapper = "Benefits-module--wrapper--2mfFi";